var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "user-notes-container"
  }, [_c('div', {
    staticClass: "heading-icon",
    staticStyle: {
      "background-color": "#2a9d8f"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "14,2 14,8 20,8"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "13",
      "x2": "8",
      "y2": "13"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "17",
      "x2": "8",
      "y2": "17"
    }
  }), _c('polyline', {
    attrs: {
      "points": "10,9 9,9 8,9"
    }
  })])]), _c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v(_vm._s(_vm.titleBlock.title || '請填寫就診資訊'))]), _c('div', {
    staticClass: "notes-content"
  }, [_vm.titleBlock.content ? _c('div', {
    staticClass: "title-desc"
  }, [_vm._v(" " + _vm._s(_vm.titleBlock.content) + " ")]) : _vm._e(), _vm.labelBlock ? _c('div', {
    staticClass: "input-section"
  }, [_c('label', {
    staticClass: "input-label"
  }, [_vm._v(_vm._s(_vm.labelBlock.title))]), _c('b-form-textarea', {
    staticClass: "custom-textarea",
    attrs: {
      "placeholder": _vm.labelBlock.content || '請輸入備註',
      "rows": "5",
      "max-rows": "10"
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: _vm.localNotes,
      callback: function callback($$v) {
        _vm.localNotes = $$v;
      },
      expression: "localNotes"
    }
  })], 1) : _vm._e(), _vm.noteBlocks.length > 0 ? _c('div', {
    staticClass: "notes-section"
  }, _vm._l(_vm.noteBlocks, function (block, index) {
    return _c('div', {
      key: index,
      staticClass: "note-item"
    }, [_c('span', {
      staticClass: "note-text"
    }, [block.title ? [_c('b', [_vm._v(_vm._s(block.title))])] : _vm._e(), _vm._v(" " + _vm._s(block.content) + " ")], 2)]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }